// HKDSE Paper 1 Knowledge Graph Samples Index
// Organized by year with systematic naming

import { hkdse2021Samples_combined } from './hkdse2021Samples_combined.js';
import { hkdse2022Samples_combined } from './hkdse2022Samples_combined.js';
import { hkdse2023Samples_combined } from './hkdse2023Samples_combined.js';
import { hkdse2024Samples_combined } from './hkdse2024Samples_combined.js';
import { hkdse2025Samples_combined } from './hkdse2025Samples_combined.js';
import { hkdse2020Samples } from './hkdse2020Samples.js';
import { hkdse2019Samples } from './hkdse2019Samples.js';
import { hkdse2018Samples } from './hkdse2018Samples.js';
import { hkdse2017Samples } from './hkdse2017Samples.js';
import { hkdse2016Samples } from './hkdse2016Samples.js';
import { hkdse2015Samples } from './hkdse2015Samples.js';

// Export individual year samples
export { 
  hkdse2021Samples_combined,
  hkdse2022Samples_combined,
  hkdse2023Samples_combined,
  hkdse2024Samples_combined,
  hkdse2025Samples_combined,
  hkdse2020Samples,
  hkdse2019Samples,
  hkdse2018Samples,
  hkdse2017Samples,
  hkdse2016Samples,
  hkdse2015Samples
};

// Combined HKDSE samples by year
export const hkdseSamples = {
  hkdse2021: hkdse2021Samples_combined,
  hkdse2022: hkdse2022Samples_combined,
  hkdse2023: hkdse2023Samples_combined,
  hkdse2024: hkdse2024Samples_combined,
  hkdse2025: hkdse2025Samples_combined,
  hkdse2020: hkdse2020Samples,
  hkdse2019: hkdse2019Samples,
  hkdse2018: hkdse2018Samples,
  hkdse2017: hkdse2017Samples,
  hkdse2016: hkdse2016Samples,
  hkdse2015: hkdse2015Samples
};

// All HKDSE samples flattened for easy access
export const allHkdseSamples = {
  ...hkdse2021Samples_combined,
  ...hkdse2022Samples_combined,
  ...hkdse2023Samples_combined,
  ...hkdse2024Samples_combined,
  ...hkdse2025Samples_combined,
  ...hkdse2020Samples,
  ...hkdse2019Samples,
  ...hkdse2018Samples,
  ...hkdse2017Samples,
  ...hkdse2016Samples,
  ...hkdse2015Samples
};

// Legacy support - maintain backward compatibility
export const allHkdseMockData = allHkdseSamples; 